module.exports = __webpack_public_path__ + "fonts/c3cececaad07bffbc7ba58dedac8de4d.svg";